'use strict';

// Settings configured here will be merged into the final config object.
export default {
  baseUrl: 'https://api.cognomos.com',
  paginationNum: 100,
  conflicts: 'conflicts',
  requirements: 'requirements',
  groups: 'groups',
  students: 'students',
  run_locks: 'run-lock-overrides',
  run_conflicts: 'run-conflict-overrides',
  run_requirements: 'run-requirement-overrides',
  group_locks: 'group-lock-overrides',
  group_conflicts: 'group-conflict-overrides',
  group_requirements: 'group-requirement-overrides',
  default_student_budget: 100,
  dndTypes: {
    CLASS: 'class',
    FAVORITE: 'favorite',
    GREAT: 'great',
    GOOD: 'good',
    ACCEPTABLE: 'acceptable'
  },
  tableRowsNum: 25,
  tableConflictNum: 10,
  tableOptions: {
    paginationShowsTotal: true,
    sizePerPageDropDown: () => <div />
  }
}



// WEBPACK FOOTER //
// ./src/config/base.js